import * as React from 'react'

import { ResolvedUserImage } from '@/components/common/resolved-media-image'

import { UserProfileHoverCard } from './user-profile-hover-card'

interface MessageUserAvatarProps {
  sender: {
    id: number
    firstName: string
    lastName: string
    avatar?: string
    profileId?: string
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSenderClick: (sender: any) => void
}

export const MessageUserAvatar: React.FC<MessageUserAvatarProps> = ({ sender, onSenderClick }) => {
  return (
    <div className="flex items-center gap-1 sm:gap-2 mb-1">
      <ResolvedUserImage
        avatar={sender.avatar}
        alt={`${sender.firstName} ${sender.lastName}`}
        size={20}
        className="h-4 w-4 sm:h-5 sm:w-5"
        placeholderClassName="h-4 w-4 sm:h-5 sm:w-5"
      />
      <UserProfileHoverCard userId={sender.id} profileId={sender.profileId}>
        <button
          onClick={() => onSenderClick(sender)}
          className="text-xs font-medium text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
          title={`View ${sender.firstName} ${sender.lastName}'s profile`}
        >
          {`${sender.firstName} ${sender.lastName}`}
        </button>
      </UserProfileHoverCard>
    </div>
  )
}
